import { UserToken } from "../data";
import Store from "../redux/store";

export function hasAdminRights() {
	const userToken : UserToken|undefined = Store.getState().localstore.userToken;
	return userToken?.role === 'ROLE_ADMIN';
}